import { TranslatePipe } from '@ngx-translate/core';
import { Component, OnInit } from '@angular/core';

import { GraphQlService } from '../../../_services';
import {
    TrainerInsertInput,
    TrainerQueryOutput,
} from '../detail/models/trainer.model';

@Component({
    selector: 'trainer-create',
    templateUrl: './create.component.html',
    styleUrls: ['../trainer.component.scss', './create.component.scss'],
    providers: [TranslatePipe],
})
export class TrainerCreateComponent implements OnInit {
    time = '';
    trainer: TrainerQueryOutput;
    availableLanguages: string[];
    initialized: boolean;

    constructor(private graphQlService: GraphQlService) {}

    ngOnInit() {
        this.trainer = {
            active: true,
            address1: '',
            address2: '',
            bio: '',
            city: '',
            companyId: null,
            company: {
                name: '',
            },
            countryCode: 'FR',
            email: '',
            firstName: '',
            interne: true,
            job: '',
            lastName: '',
            title: 'MRS',
            phone: null,
            zipCode: null,
            trainerSkills: [],
            trainerLanguages: [],
        };
        this.graphQlService
            .post({
                query: `query getLanguages {
                        languages: language {
                            code
                        }
                     }`,
                variables: {},
            })
            .subscribe(({ languages }) => {
                this.availableLanguages = languages;
                this.initialized = true;
            });
    }

    onTrainerSaved(trainer: TrainerInsertInput) {
        this.graphQlService
            .post({
                query: `
                mutation(
                    $trainer: trainer_insert_input!
                ) {
                    insertTrainer: insert_trainer(
                        objects: [$trainer]
                    ) {
                        returning {
                            id
                        }
                    }
                }`,
                variables: {
                    trainer,
                },
            })
            .subscribe(({ insertTrainer }) => {
                if (
                    insertTrainer &&
                    insertTrainer.returning[0] &&
                    insertTrainer.returning[0].id > 0
                ) {
                    window.location.assign(
                        '/#/trainer/' + insertTrainer.returning[0].id
                    );
                }
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/trainer/create/create.component.ts